import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import KanbanBoard from './KanbanBoard';
import DesignTaskProject from './DesignTaskProject';

/**
 * ProjectRouter — branches on Project.type.
 *
 * Standard projects (everything pre-DAS) render the existing KanbanBoard.
 * Design-workflow projects render the DesignTaskProject layout which
 * shows Design Tasks instead of regular Tasks.
 *
 * KanbanBoard fetches its own project internally; this router does a
 * lightweight type-only fetch to avoid loading the wrong UI even briefly.
 */
function ProjectRouter({ user, onUpdateProject, onDeleteProject }) {
  const { projectId } = useParams();
  const [type, setType] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setType(null);
    setError(null);
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`/projects/${projectId}`);
        if (cancelled) return;
        setType(res.data?.type || 'standard');
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.error || 'Failed to load project.');
        setType('error');
      }
    })();
    return () => { cancelled = true; };
  }, [projectId]);

  if (type === null) {
    return <div className="loading-screen" style={{ minHeight: 'auto', padding: '60px 0' }}>
      <div className="loading-spinner"></div>
    </div>;
  }

  if (type === 'error') {
    return <div style={{ padding: 24, color: 'var(--text-secondary)' }}>{error}</div>;
  }

  if (type === 'design-workflow') {
    return <DesignTaskProject user={user} onUpdateProject={onUpdateProject} onDeleteProject={onDeleteProject} />;
  }

  return <KanbanBoard user={user} onUpdateProject={onUpdateProject} onDeleteProject={onDeleteProject} />;
}

export default ProjectRouter;
